if (!customElements.get('so-pdp-info')) {
  class SoPdpInfo extends HTMLElement {
    connectedCallback() {
      this.modals = {};
      this._portaled = [];
      this.activeKey = null;
      this.activeTrigger = null;
      this._onKey = (e) => {
        if (e.key === 'Escape') { this.closeActive(); return; }
        if (e.key === 'Tab') this._trapTab(e);
      };

      this.querySelectorAll('[data-so-modal]').forEach((m) => {
        const key = m.getAttribute('data-so-modal');
        this.modals[key] = m;
        m.querySelectorAll('[data-so-close]').forEach((el) =>
          el.addEventListener('click', () => this.close(key)));
      });

      this.querySelectorAll('[data-so-open]').forEach((btn) => {
        const key = btn.getAttribute('data-so-open');
        btn.addEventListener('click', () => {
          // Postcode known + the shared delivery sheet loaded (so-postcode.js): open the sheet at the cart
          // subtotal so-postcode.js put on the card (a failed lookup opens it too: its own Change / Try again).
          // No postcode + config present (the card then reads "Your delivery price · Add postcode"): ask for one —
          // the postcode sheet continues to the delivery sheet. Otherwise (no so-postcode.js / no config) the Liquid modal below.
          const sd = window.soDelivery;
          if (key === 'delivery' && btn.hasAttribute('data-so-pdp-dl') && sd && typeof sd.open === 'function') {
            const hasConfig = typeof sd.config === 'function' && sd.config();
            if (sd.postcode() && hasConfig) {
              const b = parseFloat(btn.getAttribute('data-so-pdp-basis'));
              sd.open('delivery', { basis: b >= 0 ? b : undefined, returnFocus: btn });
              return;
            }
            if (hasConfig) {
              sd.open('postcode', { returnFocus: btn });
              return;
            }
          }
          this.open(key, btn);
        });
      });
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this._onKey);
      this._portaled.forEach((m) => { if (m.parentElement === document.body) m.remove(); });
    }

    // The modals are the shared .so-dsheet shell (so-delivery-sheet.css): bottom sheet on phones, centred
    // dialog from 768px. .is-open drives the slide/fade; window.soSheetSwipe (so-sheet-swipe.js, site-wide)
    // adds swipe-down-to-close on phones through the same close path as ×, backdrop and Escape.
    open(key, trigger) {
      const modal = this.modals[key];
      if (!modal) return;
      if (this.activeKey && this.activeKey !== key) this.close(this.activeKey, true);
      clearTimeout(modal._soCloseT);
      // Portal to <body> so nested stacking contexts (gallery arrows, divider) can't cover it.
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
        this._portaled.push(modal);
      }
      modal.classList.remove('is-closing');
      modal.hidden = false;
      this.activeKey = key;
      this.activeTrigger = trigger || null;
      if (!this._saved) this._saved = { html: document.documentElement.style.overflow, body: document.body.style.overflow };
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this._onKey);
      const panel = modal.querySelector('.so-dsheet__panel');
      if (window.soSheetSwipe && panel) {
        window.soSheetSwipe.attach(panel, {
          handle: '.so-dsheet__grab, .so-dsheet__head', scroller: '.so-dsheet__body',
          backdrop: modal.querySelector('.so-dsheet__backdrop'), onClose: () => this.close(key)
        });
      }
      void modal.offsetWidth;                 // reflow, then slide in
      modal.classList.add('is-open');
      const t = modal.querySelector('.so-dsheet__title');
      if (t) t.focus({ preventScroll: true });
    }

    // Keep Tab focus inside the open dialog.
    _trapTab(e) {
      const modal = this.activeKey && this.modals[this.activeKey];
      if (!modal) return;
      const f = Array.from(modal.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'));
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1], a = document.activeElement, inList = f.includes(a);
      if (e.shiftKey) {
        if (!inList || a === first) { last.focus(); e.preventDefault(); }
      } else {
        if (!inList || a === last) { first.focus(); e.preventDefault(); }
      }
    }

    close(key, swap) {
      const modal = this.modals[key];
      if (!modal || this.activeKey !== key) return;
      modal.classList.remove('is-open');
      if (swap) modal.hidden = true;
      else {
        modal.classList.add('is-closing');
        modal._soCloseT = setTimeout(() => { modal.hidden = true; modal.classList.remove('is-closing'); }, 260);
      }
      this.activeKey = null;
      if (swap) return;
      if (this._saved) {
        document.documentElement.style.overflow = this._saved.html;
        document.body.style.overflow = this._saved.body;
        this._saved = null;
      }
      document.removeEventListener('keydown', this._onKey);
      if (this.activeTrigger && this.activeTrigger.isConnected) this.activeTrigger.focus({ preventScroll: true });
      this.activeTrigger = null;
    }

    closeActive() {
      if (this.activeKey) this.close(this.activeKey);
    }
  }
  customElements.define('so-pdp-info', SoPdpInfo);
}
